import { render, staticRenderFns } from "./AddTransporterPopup.vue?vue&type=template&id=49b02974&scoped=true"
import script from "./AddTransporterPopup.vue?vue&type=script&lang=js"
export * from "./AddTransporterPopup.vue?vue&type=script&lang=js"
import style0 from "./AddTransporterPopup.vue?vue&type=style&index=0&id=49b02974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b02974",
  null
  
)

export default component.exports